import { DTOUserProfileUpdate, DTOUserWorkspaceMembershipsResponse } from "../dto";
import { DTOAuthenticatedUserResponse } from "../dto/users/authenticated-user";
import { RequestExecutor } from "../transport/request-executor";

export class UsersEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  getMe() {
    return this.requestExecutor.json("/users/me", DTOAuthenticatedUserResponse);
  }

  listWorkspaces(uid: string) {
    return this.requestExecutor.json(`/users/${uid}/workspaces`, DTOUserWorkspaceMembershipsResponse);
  }

  delete(uid: string) {
    return this.requestExecutor.json(`/users/${uid}`, DTOAuthenticatedUserResponse, { method: "DELETE" });
  }

  updateProfile(uid: string, body: DTOUserProfileUpdate) {
    return this.requestExecutor.json(`/users/${uid}/profile`, DTOAuthenticatedUserResponse, {
      method: "PUT",
      body,
    });
  }
}
